const REMEMBER_KEY = 'auth_remember_me';
const AUTH_KEYS = ['access_token', 'refresh_token', 'session_id', 'user'] as const;

export type AuthStorageKey = (typeof AUTH_KEYS)[number];

function hasLegacyLocalToken(): boolean {
  return !!localStorage.getItem('access_token');
}

/** 是否使用 localStorage 持久化登录（否则为 sessionStorage，关闭浏览器后失效） */
export function getRememberMe(): boolean {
  const explicit = localStorage.getItem(REMEMBER_KEY);
  if (explicit === '0') return false;
  if (explicit === '1') return true;
  return hasLegacyLocalToken();
}

export function setRememberMe(remember: boolean): void {
  localStorage.setItem(REMEMBER_KEY, remember ? '1' : '0');
}

export function getAuthStorage(): Storage {
  return getRememberMe() ? localStorage : sessionStorage;
}

export function clearAuthData(): void {
  for (const key of AUTH_KEYS) {
    localStorage.removeItem(key);
    sessionStorage.removeItem(key);
  }
}

export function getAuthItem(key: AuthStorageKey): string | null {
  const storage = getAuthStorage();
  const value = storage.getItem(key);
  if (value != null) return value;
  if (getRememberMe() && storage === sessionStorage) {
    return localStorage.getItem(key);
  }
  if (!getRememberMe() && storage === localStorage && key === 'access_token' && hasLegacyLocalToken()) {
    return localStorage.getItem(key);
  }
  return null;
}

export function setAuthItem(key: AuthStorageKey, value: string): void {
  getAuthStorage().setItem(key, value);
}

export function removeAuthItem(key: AuthStorageKey): void {
  localStorage.removeItem(key);
  sessionStorage.removeItem(key);
}

export function persistAuthBundle(
  data: {
    access_token: string;
    refresh_token?: string;
    session_id?: string;
    user: string;
  },
  rememberMe: boolean,
): void {
  setRememberMe(rememberMe);
  clearAuthData();
  const storage = rememberMe ? localStorage : sessionStorage;
  storage.setItem('access_token', data.access_token);
  if (data.refresh_token) storage.setItem('refresh_token', data.refresh_token);
  if (data.session_id) storage.setItem('session_id', data.session_id);
  storage.setItem('user', data.user);
}
